module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">        \n        \n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/oauthDone/oauthDone.html
// module id = 256
// module chunks = 0